import { render, staticRenderFns } from "./dialog-trashforever.vue?vue&type=template&id=cb366ee8&"
import script from "./dialog-trashforever.vue?vue&type=script&lang=js&"
export * from "./dialog-trashforever.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports